module.exports = __webpack_public_path__ + "static/MSEPLogo-4f21cde3ac94894baf4bc3c47719eeda.png";